var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25.000000pt",
    height: "25.000000pt",
    viewBox: "0 0 25.000000 25.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,25.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125 188 c-50 -21 -94 -43 -98 -47 -4 -4 10 -16 32 -25 28 -13 44 -29 57 -57 9 -22 21 -36 25 -32 7 7 89 192 89 200 0 7 -17 0 -105 -39z m59 -46 c-14 -31 -30 -68 -36 -82 l-10 -25 -16 33 -16 32 45 48 44 47 -47 -44 c-45 -42 -48 -43 -78 -31 -17 7 -28 15 -25 18 12 12 150 69 157 65 4 -2 -4 -29 -18 -61z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.a331593d4a868e4671b33d3e10d607ae.svg";
export { ForwardRef as ReactComponent };